<template>
  <div class="va-chat">
    <div
      class="va-chat__body"
      :style="{'height': height}"
      v-sticky-scroll="{
        animate: true,
        duration: 500
      }"
    >
      <div
        class="va-chat__message"
        v-for="(message, index) in value"
        :key="index"
        :class="{'va-chat__message--yours': message.yours}"
      >
        
        <va-card  :title="message.nome">
              {{ message.mensagem }}
        </va-card>



      </div>
    </div>
    <div class="va-chat__controls">
      <va-input
        v-model="inputMessage"
        @keypress.enter="sendMessage"
        placeholder="Type your message..."
        class="va-chat__input"
      />
      <va-button color="info" @click="sendMessage()">
        Enviar
      </va-button>
    </div>
  </div>
</template>

<script>
import StickyScroll from 'vuestic-ui/src/components/vuestic-directives/StickyScroll'

export default {  
  name: 'chat',
  directives: { StickyScroll },
  data () {
    return {
      inputMessage: '',
      resposta:{
        mensagem:'',
        aluno_id: this.$store.state.alunos.getAluno.id,
        oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id,
        chamado_id:this.$store.state.mensagens.setchamado.id,
        status:2

      }
    }
  },
  props: {
    value: {
      type: Array,
      default: () => [
        {
          nome: 'teste1',  
          pergunta: 'Hello! So glad you liked my work. Do you want me to shoot you?',
          resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
          yours: false,
        },
        {
          nome: 'teste2',  
          pergunta: 'Yeah, that would be cool. Maybe this Sunday at 3 pm?',
          resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
          yours: true,
        },
       
      ],
    },
    height: {
      default: '20rem',
      type: String,
    },
  },
  compouted:{
    formReady () {
      return !this.respostaErrors.length
    },
  },
  methods: {
   async sendMessage () {
      if (!this.inputMessage) {
        return
      }
      
    this.resposta = {
        titulo: 'vazio',
        perfil: '1',
        mensagem: this.inputMessage,
        funcionario_id: this.$store.state.funcionarios.setFuncionario.id,
        oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id,
        chamado_id:this.$store.state.mensagens.setchamado.id,
        status:1

      }
      console.log(this.resposta)

       await  this.$store.dispatch('addResposta',this.resposta)
       await  this.$store.dispatch('allRespostasChamadoDisciplina',this.$store.state.mensagens.setchamado)

      this.inputMessage = ''
    },
  
  },
}
</script>

<style lang='scss' scoped>
.chat {
  &__content {
    @include va-flex-center();
  }
}

$chat-message-br: .875rem;

.va-chat {
  width: 100%;

  &__body {
    min-height: 18.75rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    overflow-y: auto;
  }

  &__message {
    position: relative;
    padding: .657rem 1.375rem;
    margin-bottom: .625rem;
    max-width: 100%;
    overflow-wrap: break-word;
    border-radius: 0.5rem;
    border-top-left-radius: 0;

    align-self: flex-start;
    background-color: $light-gray2;

    &-text {
      display: block;
      transform: translateY(-2px);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &--yours {
      color: black;
      align-self: flex-end;
      border-top-right-radius: 0;
      border-top-left-radius: 0.5rem;
    }
  }

  &__controls {
    display: flex;
    align-items: center;
  }

  &__input {
    margin-bottom: 0;
  }
}
</style>
